export default __webpack_public_path__ + "static/media/turkey.b2bfc4ac.png";